import script from "./Goodkid_Home.vue?vue&type=script&setup=true&lang=js"
export * from "./Goodkid_Home.vue?vue&type=script&setup=true&lang=js"

import "./Goodkid_Home.vue?vue&type=style&index=0&id=1deb3cb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1deb3cb2"]])

export default __exports__